/** Soki-creative aligned semantic chart colors (muted on dark UI). */
export const CHART_COLORS = {
  revenue: "#9b8ec4",
  revenueMuted: "#b5aad8",
  expense: "#b893a6",
  expenseMuted: "#9b7f94",
  cashPositive: "#a78bfa",
  cashNegative: "#c4a5b8",
  focus: "#7c9fd4",
  warn: "#d4b87a",
  milestone: "#9b8ec4",
  asset: "#7ab8c9",
} as const;

/** Default color assigned to new expenses on the timeline. */
export const DEFAULT_EXPENSE_COLOR = CHART_COLORS.expense;
